module.exports = __webpack_public_path__ + "img/97.d5cf0236.jpg";